/**
 * Mobile Menu JavaScript
 * Handles mobile navigation menu functionality
 */

document.addEventListener('DOMContentLoaded', function() {   
    // Wait for Bootstrap to be ready
    setTimeout(function() {
        const navbarToggler = document.querySelector('.navbar-toggler');
        const navbarCollapse = document.querySelector('.navbar-collapse');

        console.log('Toggler found:', navbarToggler);
        console.log('Collapse found:', navbarCollapse);

        if (navbarToggler && navbarCollapse) {
            // Prevent Bootstrap's default behavior and use our own
            navbarToggler.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                // console.log('Toggler clicked');

                // Toggle the show class
                if (navbarCollapse.classList.contains('show')) {
                    navbarCollapse.classList.remove('show');
                    navbarToggler.setAttribute('aria-expanded', 'false');
                } else {
                    navbarCollapse.classList.add('show');
                    navbarToggler.setAttribute('aria-expanded', 'true');
                }
            });

            // Close menu when clicking outside
            document.addEventListener('click', function(event) {
                if (!navbarToggler.contains(event.target) && !navbarCollapse.contains(event.target)) {
                    navbarCollapse.classList.remove('show');
                    navbarToggler.setAttribute('aria-expanded', 'false');
                }
            });

            // Handle dropdown menus in mobile
            const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
            dropdownToggles.forEach(function(toggle) {
                toggle.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const dropdown = toggle.nextElementSibling;
                    if (dropdown && dropdown.classList.contains('dropdown-menu')) {
                        dropdown.classList.toggle('show');
                    }
                });
            });

            // Close menu when clicking on regular menu items (not dropdowns)
            const navLinks = document.querySelectorAll('.navbar-nav .nav-link:not(.dropdown-toggle)');
            navLinks.forEach(function(link) {
                link.addEventListener('click', function() {
                    navbarCollapse.classList.remove('show');
                    navbarToggler.setAttribute('aria-expanded', 'false');
                });
            });
        }
    }, 100);
});
